// extracted by mini-css-extract-plugin
export default {"bannerDiv":"banner_bannerDiv__6I+8y"};